import React from 'react'

import Link from '@Pure/Link'

import { mergeDeep } from '@root/utility'

export let form =
{
	model: 'age',
	name: 'age',

	form_title: 'Tranche d\'age',

	fields:
	{
		'label':
		{
			label: 'Libellé'
		}
	},

	create_label: 'Créer cet age',

	get__deleteModalText: function (form_data)
	{
		var output =
		(
			<span>
				<p>
					Êtes vous sûr de vouloir supprimer cette tranche d'age&nbsp;?
				</p>

				<div className="u-center">

					<div className="name-in-modal">

						{ form_data['age[label]'] }

					</div>

				</div>
			</span>
		);

		return output;
	},

	get__createdMessage: function (model)
	{
		var output =
		(
			<div className="c-message c-message--green">
				<div className="c-message__content">
					La nouvelle tranche d'age <strong> { model.label } </strong> a été créée.
					{ ' ' }
					<Link className="c-link c-link--highlighted c-link--green"
						href={ '/configuration/tranches-d-ages/' + model.id }>
						Voir la page de la tranche d'age
					</Link>
				</div>
			</div>
		);

		return output;
	}
}

export let list =
{
	model: 'age',
	title: 'Liste des tranches d\'age',
	link: '/configuration/tranches-d-ages',
	creation_link: '/configuration/nouvel-age',
	creation_label: 'Nouvelle tranche d\'age',
	header_map:
	{
		'Libellé': 'label'
	},
	row_link_base: '/configuration/tranches-d-ages/',
	searched_prop: 'label'
}

let config = mergeDeep({ }, form);

config = mergeDeep(form, list);

export default config